import { render, staticRenderFns } from "./MegaMenuView.vue?vue&type=template&id=146bff52&"
import script from "./MegaMenuView.vue?vue&type=script&lang=js&"
export * from "./MegaMenuView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports